import { useMemo } from 'react';

import { navigate } from '@redwoodjs/router';

import CommissionType from 'src/features/finance/commissionStatement/constants/commissionType';
import {
    useCommissionStatementsFilters,
    useFilteredCommissionStatements,
} from 'src/features/finance/commissionStatement/hooks';
import { enumToCamelCase } from 'src/lib/formatters';
import { commissionFilters } from 'src/utils/tableUtils';

type UseViewCommissionStatementInput = {
    commissionType: CommissionType;
};

export function useViewCommissionStatement({ commissionType }: UseViewCommissionStatementInput) {
    const { idFilters, partnerNameFilters } = useCommissionStatementsFilters({ commissionType });

    const commissionTypeLowerCase = commissionType.toLowerCase();
    const commissionTypeCamelCase = enumToCamelCase(commissionType);

    const handleViewCommission = (id) => {
        navigate(`/finance/commissions/${commissionTypeLowerCase}/${id}`);
    };

    const filterOptions = useMemo(() => {
        return commissionFilters(idFilters, partnerNameFilters);
    }, [idFilters, partnerNameFilters]);

    const { filteredData, setTableFilters, loading } = useFilteredCommissionStatements({
        commissionType,
    });

    return {
        handleViewCommission,
        commissionTypeLowerCase,
        commissionTypeCamelCase,
        filterOptions,
        setTableFilters,
        tableData: filteredData,
        loading,
    };
}

export default useViewCommissionStatement;
